import api from '../api';
import { tokenService } from '../auth/tokenService';

export const supportService = {
  getList: async (params) => {
    try {
      const response = await api.get('support-assist/cms/filtered/paginated', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  ticketsByUser: async (user_id, params) => {
    try {
      const response = await api.get(`support-assist/user/${user_id}`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`support-assist/cms/request/${id}`, data, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMovements: async (user_id) => {
    try {
      const response = await api.get(`tokens/history/user/${user_id}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  downloadSupport: async (params = {}) => {
    const response = await api.get("support-assist/cms/filtered/paginated", {
      responseType: "blob",
      params: {
        ...params,
        download: "excel",
      },
      headers: {
        Authorization: `Bearer ${tokenService.getAccessToken()}`,
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "support.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return response.data;
  },
};
